import React from 'react';
import { motion } from 'framer-motion';
import './UseCases.css';

const useCases = [
  {
    emoji: '🎤',
    title: 'Presentations',
    description: 'Turn scattered notes into a coherent presentation outline'
  },
  {
    emoji: '💼',
    title: 'Sales Pitches',
    description: 'Structure your value proposition and key talking points'
  },
  {
    emoji: '🚿',
    title: 'Shower Thoughts',
    description: 'Capture those brilliant ideas before they slip away'
  },
  {
    emoji: '💡',
    title: 'Ideas & Brainstorms',
    description: 'Organize creative chaos into actionable concepts'
  }
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4 }
  }
};

const UseCases = () => {
  return (
    <section className="use-cases">
      <motion.div
        className="use-cases-grid"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
      >
        {useCases.map((useCase, index) => (
          <motion.div
            key={index}
            className="use-case-card"
            variants={cardVariants}
            whileHover={{ y: -8, transition: { duration: 0.2 } }}
          >
            <span className="use-case-emoji">{useCase.emoji}</span>
            <h3 className="use-case-title">{useCase.title}</h3>
            <p className="use-case-description">{useCase.description}</p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default UseCases;
